import React, { Suspense, lazy } from 'react';
import Loading from '../LoadingComponent';

const PointGrant = lazy(() =>
  import(/* webpackChunkName: "PointGrant" */ '../../components/rewards/PointGrant')
);

export default function PointGrantComponent({...props}) {
  return (
    <Suspense fallback={<Loading />}>
      <PointGrant {...props} />
    </Suspense>
  );
}
